(function (algolia) {
  'use strict';
  const insightsClient = algolia.externals.insightsClient;
  const createAlgoliaInsightsPlugin =
    algolia.externals.createAlgoliaInsightsPlugin;
  const createInsightsMiddleware = algolia.externals.createInsightsMiddleware;
  algolia.userTokenCheck = false;

  const enabled = algolia.config.analytics_enabled;
  if (!enabled) return;

  const getUsertoken = () => {
    let userToken;
    insightsClient('getUserToken', null, (err, newUserToken) => {
      if (err) {
        console.error(err);
        return;
      }
      userToken = newUserToken;
    });
  };

  /**
   * To set the userToken parameter globally
   *
   * @param userToken
   */
  const setUserTokenGlobally = (userToken) => {
    insightsClient('setUserToken', userToken);
  };

  /**
   * get userToken from cookie
   */

  function getUserTokenFromCookie() {
    const userTokenCookie = document.cookie.match(/_ALGOLIA=[^;]+/);
    const [userTokenKeyValue] = userTokenCookie || '';
    const [userToken] = userTokenKeyValue
      ? userTokenKeyValue.split('=').splice(1)
      : [null];
    return userToken;
  };

  const saveUserTokenToCookie = (cookieName, cookieValue, expirationDays) => {
    const date = new Date();
    date.setTime(date.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${cookieName}=${cookieValue};${expires};path=/`;
  };

  // check oneTrust cookie accepted or not
  const setAlgoliaCookie = () => {
    const performanceCookieCategory = 'C0002,';
    if (window.hasOwnProperty('OnetrustActiveGroups')) {
      return !!window.OnetrustActiveGroups.includes(performanceCookieCategory);
    };
    return null;
  };

  // useCookie parameter set up
  const userTokenAdminSetting =
    algolia.config.usertoken_with_cookies === 'enabled';
  // Generate a random alpha-numeric string that's 20 characters long
  const randomUserToken = Array.from(Array(20), () =>
    Math.floor(Math.random() * 36).toString(36)
  ).join('');

  if (userTokenAdminSetting) {
    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      (error) => {
        if (error) {
          console.error('Customer Privacy API Error', error);
        }
        const userCanBeTracked = window.Shopify.customerPrivacy
          ? window.Shopify.customerPrivacy.userCanBeTracked()
          : false;
        const useCookie = userTokenAdminSetting && userCanBeTracked;
        insightsClient('init', {
          appId: algolia.config.app_id,
          apiKey: algolia.config.search_api_key,
          useCookie : setAlgoliaCookie(), // this needs to be tied to OneTrust User Preference,
        });

        if(useCookie && userCanBeTracked) {
          if(!getUserTokenFromCookie()){
            saveUserTokenToCookie('_ALGOLIA', randomUserToken, 7);
            insightsClient('setUserToken', randomUserToken);
          } else if (window.theme?.customer) {
            insightsClient('setUserToken', (window.theme.customer.id).toString());
          } else {
            const userTokenFromCookie = getUserTokenFromCookie();
            insightsClient('setUserToken', userTokenFromCookie);
          }
        }
        algolia.userTokenCheck = true;
        algolia.insightsClient = insightsClient
      }
    );
  } else {
    window.insightsClient('init', {
      appId: algolia.config.app_id,
      apiKey: algolia.config.search_api_key,
    });
    window.insightsClient('setUserToken', randomUserToken);
  }

  // Autocomplete insight initialization
  algolia.algoliaInsightsPlugin = createAlgoliaInsightsPlugin({
    insightsClient,
  });
  // IS insight initialization
  algolia.insightsMiddleware = createInsightsMiddleware({ insightsClient });

  // Local storage logic for conversion events
  const localStorageKey = 'algolia_analytics_clicked_objects';

  /**
   * Saves details in local storage for conversion tracking
   */
  algolia.saveForConversionTracking = function (data) {
    /**
     * We're using a try, catch here to handle any possible exceptions
     * resulting from local storage or JSON parsing.
     */
    try {
      // Get any data previously stored
      const previousClickItemsString =
        localStorage.getItem(localStorageKey) || '[]';
      const previousClickItems = JSON.parse(previousClickItemsString);

      var conversionData = data;

      if (conversionData.eventName === 'click') {
        // Changing the event to 'Added to cart' from 'click'
        conversionData.eventName = 'add-to-cart';
        // Removing the `positions` property if the event comes from IS
        delete conversionData.positions;
      }

      // Add the current products data to local storage
      previousClickItems.push(conversionData);
      localStorage.setItem(localStorageKey, JSON.stringify(previousClickItems));
    } catch (error) {
      // No need to do anything in this scenario
    }
  };

/**
 * get userToken to cookie
 */


  /**
   * Try to get the details from local storage for conversion tracking.
   * We're using a try...catch here to handle any possible exceptions resulting
   * from local storage or JSON parsing.
   */
   function trackConversion() {
    //Retrieving userToken
    const userToken = window.theme?.customer
      ? (window.theme.customer.id).toString() : getUserTokenFromCookie();


    try {
      // Get any previously stored data.
      const previousClickItemsString = localStorage.getItem(localStorageKey);
      // If data was found, send a conversion event for those products.
      if (!!previousClickItemsString) {
        const previousClickItems = JSON.parse(previousClickItemsString);
        previousClickItems.forEach((data) => {
          data = { ...data, userToken };

          if(data.eventName == 'add-to-cart') {
            algolia.insightsClient('convertedObjectIDsAfterSearch', data);
          }
        });
      }
    } catch (error) {
      // No need to do anything in this scenario.
    }

    // Try to remove the items from local storage.
    try {
      localStorage.removeItem(localStorageKey);
    } catch (error) {
      // No need to do anything in this scenario.
    }
  }

  /**
   *Track a conversion event when clicking the 'add to cart' button.
   *Change the query selector to be the correct one for your theme.
   */
  const addToCartAlgolia = () => {
    trackConversion();
  };

  window.addToCartAlgolia = addToCartAlgolia;

})(window.algoliaShopify);
